import {AbilityBuilder, AnyMongoAbility} from '@casl/ability';
import {PolicyIdentity} from './policy-account';

/**
 * Account Image Authorization Policies
 *
 * AccountImage permissions derive from Account permissions: an identity can
 * read/update/delete the images of each account it owns. Admin coverage needs
 * no rules here — TenantAdmin's `can('manage', 'all', {tenantId})` and
 * SystemAdmin's `can('manage', 'all')` from defineGlobalPolicies match image
 * documents once they carry tenantId.
 */
export function defineAccountImagePolicies(identity: PolicyIdentity, builder: AbilityBuilder<AnyMongoAbility>): void {
  const {can} = builder;

  // Self-grant: each account in the identity can read/update/delete its own images.
  for (const account of identity.accounts) {
    can(['read', 'update', 'delete'], 'AccountImage', {accountId: account.id});
  }
}
